import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { ItemName } from 'components/project/FloorBidderScreen';
import styled from 'styled-components';

const Container = styled.div`
  grid-area: product;
  display: flex;
  padding: 0px 5px;
  text-align: center;
  align-items: center;
  max-width: 100%;
  justify-content: center;
  font-size: ${({ largerFont }) => (largerFont ? 'min(4vw, 5em)' : 'min(2vw, 3em)')};
`;

const ItemNameContainer = ({ largerFont }) => (
  <Container largerFont={largerFont}>
    <ItemName />
  </Container>
);

ItemNameContainer.propTypes = {
  largerFont: PropTypes.bool,
};

ItemNameContainer.defaultProps = {
  largerFont: false,
};
export default observer(ItemNameContainer);
